import React from 'react';

// Auth pages
export const Login = React.lazy(() => import('../pages/Login'));
export const Signup = React.lazy(() => import('../pages/Signup'));
export const VerifyEmail = React.lazy(() => import('../pages/VerifyEmail'));
export const VerifyEmailLanding = React.lazy(() => import('../pages/VerifyEmailLanding'));
export const ResetPassword = React.lazy(() => import('../pages/ResetPassword'));

// Shop pages
export const HomePage = React.lazy(() => import('../pages/shop/HomePage'));
export const Shop = React.lazy(() => import('../pages/shop/Shop'));
export const ProductDetail = React.lazy(() => import('../pages/shop/ProductDetail'));
export const Checkout = React.lazy(() => import('../pages/shop/Checkout'));
export const OrderConfirmation = React.lazy(() => import('../pages/shop/OrderConfirmation'));
export const BrandPage = React.lazy(() => import('../pages/shop/BrandPage'));
export const CustomerAuth = React.lazy(() => import('../pages/shop/CustomerAuth'));
export const CustomerProfile = React.lazy(() => import('../pages/shop/CustomerProfile'));
export const CustomerOrders = React.lazy(() => import('../pages/shop/CustomerOrders'));
export const OrderLookup = React.lazy(() => import('../pages/shop/OrderLookup'));
export const Terms = React.lazy(() => import('../pages/shop/Terms'));
export const Privacy = React.lazy(() => import('../pages/shop/Privacy'));
export const ShopifyAppPrivacy = React.lazy(() => import('../pages/shop/ShopifyAppPrivacy'));
export const ReturnPolicy = React.lazy(() => import('../pages/shop/ReturnPolicy'));
export const Integrations = React.lazy(() => import('../pages/shop/Integrations'));
export const JoinWaitlist = React.lazy(() => import('../pages/shop/JoinWaitlist'));
export const SellOnArkx = React.lazy(() => import('../pages/shop/SellOnArkx'));
export const AccessRedeem = React.lazy(() => import('../pages/shop/AccessRedeem'));
export const ArkxLogistics = React.lazy(() => import('../pages/shop/ArkxLogistics'));
export const Likes = React.lazy(() => import('../pages/shop/Likes'));

// Driver pages
export const DriverDashboard = React.lazy(() => import('../pages/DriverDashboard'));

// Portal pages
export const Dashboard = React.lazy(() => import('../pages/Dashboard'));
export const DarkstoreBrand = React.lazy(() => import('../pages/DarkstoreBrand'));
export const DarkstoreListings = React.lazy(() => import('../pages/DarkstoreListings'));
export const Orders = React.lazy(() => import('../pages/Orders'));
export const OrderDetail = React.lazy(() => import('../pages/OrderDetail'));
export const Payouts = React.lazy(() => import('../pages/Payouts'));
export const AdjustInventory = React.lazy(() => import('../pages/AdjustInventory'));
export const AdjustReview = React.lazy(() => import('../pages/AdjustReview'));
export const Transfers = React.lazy(() => import('../pages/Transfers'));
export const Transactions = React.lazy(() => import('../pages/Transactions'));
export const History = React.lazy(() => import('../pages/History'));
export const Settings = React.lazy(() => import('../pages/Settings'));
export const Products = React.lazy(() => import('../pages/Products'));
export const CreateProduct = React.lazy(() => import('../pages/CreateProduct'));
export const EditProduct = React.lazy(() => import('../pages/EditProduct'));
export const ProductInventory = React.lazy(() => import('../pages/ProductInventory'));
export const UnderConstruction = React.lazy(() => import('../pages/UnderConstruction'));
export const Analytics = React.lazy(() => import('../pages/Analytics'));

// Admin pages
export const AdminDashboard = React.lazy(() => import('../pages/admin/AdminDashboard'));
export const AdminOrders = React.lazy(() => import('../pages/AdminOrders'));
export const ManageUsers = React.lazy(() => import('../pages/admin/ManageUsers'));
export const ManageCompanies = React.lazy(() => import('../pages/admin/ManageCompanies'));
export const AuditLogs = React.lazy(() => import('../pages/admin/AuditLogs'));
export const AdminPayouts = React.lazy(() => import('../pages/admin/AdminPayouts'));
export const AdminDeliveries = React.lazy(() => import('../pages/admin/AdminDeliveries'));
export const AdminTransfers = React.lazy(() => import('../pages/admin/AdminTransfers'));
export const FinancialLedger = React.lazy(() => import('../pages/admin/FinancialLedger'));
export const InventoryLedger = React.lazy(() => import('../pages/admin/InventoryLedger'));
export const AdminEmail = React.lazy(() => import('../pages/admin/AdminEmail'));
export const AdminSettings = React.lazy(() => import('../pages/admin/AdminSettings'));
export const AdminDarkstore = React.lazy(() => import('../pages/admin/AdminDarkstore'));
